export default __webpack_public_path__ + "static/media/safeplace.4c2942d2.jpg";